import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JWT: { input: any; output: any; }
  URL: { input: string; output: string; }
  Upload: { input: import("graphql-upload-minimal").Upload; output: import("graphql-upload-minimal").Upload; }
};

export type Analytics = {
  __typename?: 'Analytics';
  currentPeriodOrders: Array<OrdersData>;
  currentPeriodOrdersQuantity: Scalars['Int']['output'];
  currentPeriodOrdersValue: Scalars['Float']['output'];
  previousPeriodOrders: Array<OrdersData>;
  previousPeriodOrdersQuantity: Scalars['Int']['output'];
  previousPeriodOrdersValue: Scalars['Float']['output'];
};

export type AppliedDeduction = {
  __typename?: 'AppliedDeduction';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  type: DeductionType;
};

export type AuthTokens = {
  __typename?: 'AuthTokens';
  accessToken: Scalars['JWT']['output'];
  idToken: Scalars['JWT']['output'];
  refreshToken: Scalars['JWT']['output'];
};

export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  tokens: AuthTokens;
  user: User;
};

export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  countryCode: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  last4Digits: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BaseImage = {
  altText?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  url: Scalars['URL']['output'];
  width: Scalars['Int']['output'];
};

export type CalculatedProductCommission = {
  __typename?: 'CalculatedProductCommission';
  amount: Scalars['Float']['output'];
  /** The value the percentage was applied to: unit price, or unit profit under a PROFIT basis. */
  base?: Maybe<Scalars['Float']['output']>;
  /** The basis actually applied — may be NET_SALES even when PROFIT is configured, if no cost was available. */
  basis?: Maybe<CommissionBasis>;
  percentage: Scalars['Float']['output'];
  /** Null unless the merchant has enabled showSellerCost — stripped server-side, not just hidden in the UI. */
  unitCost?: Maybe<Scalars['Float']['output']>;
};

export type CalculatedSellerOrderCommission = {
  __typename?: 'CalculatedSellerOrderCommission';
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type CalculatedShippingCommission = {
  __typename?: 'CalculatedShippingCommission';
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type CancelSellerOrderDetailsInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  refund?: InputMaybe<Scalars['Boolean']['input']>;
  restock?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CommissionBasis {
  NetSales = 'NET_SALES',
  Profit = 'PROFIT'
}

export type CommissionBasisSetting = {
  __typename?: 'CommissionBasisSetting';
  basis: CommissionBasis;
  showSellerCost: Scalars['Boolean']['output'];
};

export type CompleteRegistrationInput = {
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Connection = {
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<Maybe<Edge>>>;
  pageInfo: PageInfo;
};

export type Customer = {
  __typename?: 'Customer';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CustomerAddress>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  provinceCode?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type DashboardActions = {
  __typename?: 'DashboardActions';
  ordersPendingApproval: Scalars['Int']['output'];
  ordersPendingFulfillment: Scalars['Int']['output'];
};

export type DashboardMetric = {
  __typename?: 'DashboardMetric';
  changePercent: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type DateRangeInput = {
  customRange?: InputMaybe<PeriodRangeInput>;
  periodType: PeriodType;
};

export type Deduction = {
  __typename?: 'Deduction';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  type: DeductionType;
};

export enum DeductionType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type DeductionsSetting = {
  __typename?: 'DeductionsSetting';
  deductions: Array<Deduction>;
};

export type DeliveryProcessingTime = {
  __typename?: 'DeliveryProcessingTime';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  unit: DeliveryProcessingTimeUnit;
};

export type DeliveryProcessingTimeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  unit: DeliveryProcessingTimeUnit;
};

export enum DeliveryProcessingTimeUnit {
  Day = 'DAY',
  Week = 'WEEK'
}

export type DeliveryProfile = {
  __typename?: 'DeliveryProfile';
  createdAt?: Maybe<Scalars['Date']['output']>;
  default: DeliveryRate;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originCountryCode: Scalars['String']['output'];
  originPostalCode?: Maybe<Scalars['String']['output']>;
  originRegionCode?: Maybe<Scalars['String']['output']>;
  otherInternational?: Maybe<DeliveryRate>;
  processingTime: DeliveryProcessingTime;
  productCount: Scalars['Int']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  zones: Array<DeliveryZone>;
};

export type DeliveryRate = {
  __typename?: 'DeliveryRate';
  additionalItemRate?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  type: DeliveryRateType;
};

export type DeliveryRateInput = {
  additionalItemRate?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  type: DeliveryRateType;
};

export enum DeliveryRateType {
  FixedPrice = 'FIXED_PRICE',
  FreeDelivery = 'FREE_DELIVERY'
}

export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  countries: Array<DeliveryZoneCountry>;
  id: Scalars['ID']['output'];
  rate: DeliveryRate;
};

export type DeliveryZoneCountry = {
  __typename?: 'DeliveryZoneCountry';
  code: Scalars['String']['output'];
};

export type DeliveryZoneCountryInput = {
  countryCode: Scalars['String']['input'];
  regions?: InputMaybe<Array<DeliveryZoneRegionInput>>;
};

export type DeliveryZoneInput = {
  countries: Array<DeliveryZoneCountryInput>;
  id: Scalars['String']['input'];
  processingTime: DeliveryProcessingTimeInput;
  rate: DeliveryRateInput;
};

export type DeliveryZoneRegionInput = {
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<Node>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  createdAt: Scalars['Date']['output'];
  shippingCarrier?: Maybe<Scalars['String']['output']>;
  shippingCarrierId?: Maybe<Scalars['String']['output']>;
  status: FulfillmentStatus;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type FulfillmentDetailsInput = {
  trackingInfo?: InputMaybe<TrackingDetailsInput>;
};

export enum FulfillmentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type Image = BaseImage & {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  url: Scalars['URL']['output'];
  width: Scalars['Int']['output'];
};

export enum InlineShippingOptions {
  DomesticOnly = 'DOMESTIC_ONLY',
  InternationalMandatory = 'INTERNATIONAL_MANDATORY',
  InternationalOptional = 'INTERNATIONAL_OPTIONAL'
}

/**
 * The state of an invitation link. EXPIRED and ALREADY_USED are the two cases a
 * seller can act on — the first needs a new invitation, the second means they
 * already have an account — and telling them apart is the point of this type.
 */
export enum InvitationStatus {
  AlreadyUsed = 'ALREADY_USED',
  Expired = 'EXPIRED',
  Malformed = 'MALFORMED',
  Unknown = 'UNKNOWN',
  Valid = 'VALID'
}

export type InvitationValidation = {
  __typename?: 'InvitationValidation';
  status: InvitationStatus;
};

export enum ManualPayoutTransactionType {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  Other = 'OTHER'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AuthenticatedUser;
  acceptSellerOrder?: Maybe<SellerOrder>;
  acceptTerms: Seller;
  addProductImage: ProductImageFile;
  cancelSellerOrder?: Maybe<SellerOrder>;
  completeRegistration: User;
  createProduct?: Maybe<Product>;
  deletePayoutAccount: Seller;
  deleteProduct?: Maybe<Scalars['Boolean']['output']>;
  forgotPassword: Scalars['Boolean']['output'];
  forgotPasswordReset: Scalars['Boolean']['output'];
  fulfillSellerOrder?: Maybe<SellerOrder>;
  login: AuthenticatedUser;
  loginSession: AuthenticatedUser;
  logout: Scalars['Boolean']['output'];
  refreshAccessToken: AuthenticatedUser;
  register: AuthenticatedUser;
  resendCode: Scalars['Boolean']['output'];
  setDeliveryProfile: DeliveryProfile;
  setSeller?: Maybe<Seller>;
  /**
   * Correct the tracking details of an order that is already fulfilled.
   *
   * Separate from fulfillSellerOrder because that transitions the order; this
   * only edits the tracking a seller has already supplied — a mistyped tracking
   * number shouldn't require cancelling and re-fulfilling.
   */
  updateFulfillment?: Maybe<SellerOrder>;
  updateProduct?: Maybe<Product>;
  updateSeller?: Maybe<Seller>;
  verifyCode: User;
};


export type MutationAcceptInvitationArgs = {
  invitationCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAcceptSellerOrderArgs = {
  accepted: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAcceptTermsArgs = {
  version: Scalars['String']['input'];
};


export type MutationAddProductImageArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationCancelSellerOrderArgs = {
  details: CancelSellerOrderDetailsInput;
  id: Scalars['ID']['input'];
};


export type MutationCompleteRegistrationArgs = {
  completeRegistration: CompleteRegistrationInput;
};


export type MutationCreateProductArgs = {
  product: ProductInput;
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationForgotPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationForgotPasswordResetArgs = {
  value: PasswordResetInput;
};


export type MutationFulfillSellerOrderArgs = {
  details?: InputMaybe<FulfillmentDetailsInput>;
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  value: UserLoginInput;
};


export type MutationLoginSessionArgs = {
  value: UserLoginTokensInput;
};


export type MutationRefreshAccessTokenArgs = {
  refreshToken: Scalars['JWT']['input'];
  username: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  value: RegisterUserInput;
};


export type MutationResendCodeArgs = {
  username: Scalars['String']['input'];
};


export type MutationSetDeliveryProfileArgs = {
  deliveryProfile: SetDeliveryProfileInput;
};


export type MutationSetSellerArgs = {
  input: SetSellerInput;
};


export type MutationUpdateFulfillmentArgs = {
  id: Scalars['ID']['input'];
  trackingInfo: TrackingDetailsInput;
};


export type MutationUpdateProductArgs = {
  disableProductUntilChangesApproved?: InputMaybe<Scalars['Boolean']['input']>;
  product: ProductInput;
};


export type MutationUpdateSellerArgs = {
  seller: SellerInput;
};


export type MutationVerifyCodeArgs = {
  value: VerifyCodeInput;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type OrdersData = {
  __typename?: 'OrdersData';
  key: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetInput = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type Payout = Node & {
  __typename?: 'Payout';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  idAlias: Scalars['String']['output'];
  orders?: Maybe<SellerOrderConnection>;
  payout?: Maybe<PayoutCalculation>;
  payoutDate?: Maybe<Scalars['Date']['output']>;
  payoutDueDate?: Maybe<Scalars['Date']['output']>;
  transaction: PayoutTransaction;
};


export type PayoutOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PayoutAccount = PaypalPayoutAccount | StripePayoutAccount;

export type PayoutAdjustment = {
  __typename?: 'PayoutAdjustment';
  amount: Scalars['Float']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type PayoutAdjustmentInput = {
  amount: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutCalculation = {
  __typename?: 'PayoutCalculation';
  adjustment?: Maybe<PayoutAdjustment>;
  calculatedPayoutAmount: Scalars['Float']['output'];
  payoutAmount: Scalars['Float']['output'];
};

export type PayoutConnection = Connection & {
  __typename?: 'PayoutConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<Maybe<PayoutEdge>>>;
  pageInfo: PageInfo;
};

export type PayoutEdge = Edge & {
  __typename?: 'PayoutEdge';
  cursor: Scalars['String']['output'];
  node: Payout;
};

export type PayoutManualTo = {
  __typename?: 'PayoutManualTo';
  amount: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  note: Scalars['String']['output'];
  type: ManualPayoutTransactionType;
};

export type PayoutOptions = {
  __typename?: 'PayoutOptions';
  paypal: Scalars['Boolean']['output'];
  stripe: Scalars['Boolean']['output'];
};

export type PayoutPaypalFrom = {
  __typename?: 'PayoutPaypalFrom';
  amount: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type PayoutPaypalTo = {
  __typename?: 'PayoutPaypalTo';
  amount: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum PayoutPeriodChoice {
  PostFulfillment = 'POST_FULFILLMENT',
  PostOrder = 'POST_ORDER',
  PostReturnPeriod = 'POST_RETURN_PERIOD'
}

export type PayoutPeriodSetting = {
  __typename?: 'PayoutPeriodSetting';
  payoutPeriod: Scalars['Int']['output'];
  payoutPeriodChoice: PayoutPeriodChoice;
};

export enum PayoutStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  None = 'NONE',
  Paid = 'PAID',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED'
}

export type PayoutStripeTo = {
  __typename?: 'PayoutStripeTo';
  accountName: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  bankName: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  last4Digits: Scalars['String']['output'];
};

export type PayoutTransaction = PayoutTransactionManual | PayoutTransactionPaypal | PayoutTransactionStripe;

export type PayoutTransactionManual = {
  __typename?: 'PayoutTransactionManual';
  reference: Scalars['String']['output'];
  to: PayoutManualTo;
};

export type PayoutTransactionPaypal = {
  __typename?: 'PayoutTransactionPaypal';
  from: PayoutPaypalFrom;
  reference: Scalars['String']['output'];
  to: PayoutPaypalTo;
  transactionId: Scalars['String']['output'];
};

export type PayoutTransactionStripe = {
  __typename?: 'PayoutTransactionStripe';
  to: PayoutStripeTo;
  transactionId: Scalars['String']['output'];
};

export type PaypalPayoutAccount = {
  __typename?: 'PaypalPayoutAccount';
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type PeriodRangeInput = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export enum PeriodType {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  Last_180Days = 'LAST_180_DAYS',
  Last_365Days = 'LAST_365_DAYS',
  Today = 'TODAY'
}

export type Product = Node & {
  __typename?: 'Product';
  createdAt: Scalars['Date']['output'];
  createdBy: ProductUserContext;
  current?: Maybe<ProductInfo>;
  id: Scalars['ID']['output'];
  idAlias: Scalars['String']['output'];
  isDetatched: Scalars['Boolean']['output'];
  pending?: Maybe<ProductInfo>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  reviewStatus: ProductReviewStatus;
  settings?: Maybe<ProductSettings>;
  status: ProductStatus;
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<ProductUserContext>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  pageInfo: PageInfo;
};

export type ProductEdge = Edge & {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductFeeSetting = {
  __typename?: 'ProductFeeSetting';
  productFee: Scalars['Int']['output'];
};

export type ProductImage = Node & {
  __typename?: 'ProductImage';
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: ProductImageFile;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
};

export type ProductImageConnection = Connection & {
  __typename?: 'ProductImageConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<Maybe<ProductImageEdge>>>;
  pageInfo: PageInfo;
};

export type ProductImageEdge = Edge & {
  __typename?: 'ProductImageEdge';
  cursor: Scalars['String']['output'];
  node: ProductImage;
};

export type ProductImageFile = BaseImage & {
  __typename?: 'ProductImageFile';
  altText?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  thumbnailUrl: Scalars['URL']['output'];
  url: Scalars['URL']['output'];
  width: Scalars['Int']['output'];
};

export type ProductImageItemInput = {
  id: Scalars['ID']['input'];
  isFeatured: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
};

export type ProductInfo = {
  __typename?: 'ProductInfo';
  deliveryProfile?: Maybe<DeliveryProfile>;
  description: Scalars['String']['output'];
  images?: Maybe<Array<ProductImage>>;
  options?: Maybe<Array<ProductOption>>;
  productType: ProductType;
  standardShipping?: Maybe<StandardShipping>;
  title: Scalars['String']['output'];
  variants: Array<ProductVariant>;
};

export type ProductInput = {
  deliveryProfileId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<ProductImageItemInput>>;
  options?: InputMaybe<Array<ProductOptionInput>>;
  productType: ProductType;
  standardShipping?: InputMaybe<StandardShippingInput>;
  title: Scalars['String']['input'];
  variants: Array<ProductVariantInput>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ProductOptionInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  values: Array<Scalars['String']['input']>;
};

export type ProductPercentageSetting = {
  __typename?: 'ProductPercentageSetting';
  productPercentage: Scalars['Int']['output'];
};

export type ProductPublishSetting = {
  __typename?: 'ProductPublishSetting';
  activateOnAccept: Scalars['Boolean']['output'];
  publishOnlineOnAccept: Scalars['Boolean']['output'];
};

export enum ProductReviewAction {
  ContentReview = 'CONTENT_REVIEW',
  FullReview = 'FULL_REVIEW',
  None = 'NONE'
}

export type ProductReviewSetting = {
  __typename?: 'ProductReviewSetting';
  reviewAction: ProductReviewAction;
};

export enum ProductReviewStatus {
  Approved = 'APPROVED',
  ChangesPending = 'CHANGES_PENDING',
  ChangesRejected = 'CHANGES_REJECTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProductSettings = {
  __typename?: 'ProductSettings';
  commissionBasis: CommissionBasisSetting;
  productFee: ProductFeeSetting;
  productPercentage: ProductPercentageSetting;
  productReview: ProductReviewSetting;
  returns: ReturnsSetting;
  shippingPercentage: ShippingPercentageSetting;
};

export type ProductShippingSetting = {
  __typename?: 'ProductShippingSetting';
  allowAllInternationalShippingCountries: Scalars['Boolean']['output'];
  allowProfiles: Scalars['Boolean']['output'];
  allowedInternationalShippingCountries: Array<Scalars['String']['output']>;
  customShippingCountryOfOriginList: Array<Scalars['String']['output']>;
  hideSelectCountryIfSingleCountry: Scalars['Boolean']['output'];
  inlineShippingOptions: InlineShippingOptions;
  shippingCountryOfOriginOption: ShippingCountryOfOriginOption;
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  New = 'NEW'
}

/**
 * The counts shown beside the products heading. Status and review status are
 * independent — a product can be live while its latest edit is still with the
 * shop — so awaitingReview and changesRequested overlap the status counts rather
 * than partitioning them.
 */
export type ProductStatusCounts = {
  __typename?: 'ProductStatusCounts';
  active: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  /** Waiting on the shop: a new product, or edits to a live one. */
  awaitingReview: Scalars['Int']['output'];
  /** Sent back by the shop and waiting on the seller. */
  changesRequested: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ProductType {
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL'
}

export enum ProductTypeOptions {
  Both = 'BOTH',
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL'
}

export type ProductTypeSetting = {
  __typename?: 'ProductTypeSetting';
  productType: ProductTypeOptions;
};

export enum ProductUserContext {
  App = 'APP',
  Seller = 'SELLER',
  Shop = 'SHOP'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  barcode?: Maybe<Scalars['String']['output']>;
  /** Compare-at price in INTEGER CENTS, as `price` above. */
  compareAtPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ProductImageFile>;
  initialQuantity?: Maybe<Scalars['Int']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Selling price in INTEGER CENTS: 1999 is $19.99.
   *
   * Every money field this API carries is integer cents, which is also how it is
   * stored (MPPRO-45). Clients convert for display and for the figure a person
   * types, and nothing in between divides by 100.
   */
  price: Scalars['Float']['output'];
  productId: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityAdjustment?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  taxable?: Maybe<Scalars['Boolean']['output']>;
  trackQuantity?: Maybe<Scalars['Boolean']['output']>;
  variantOptions?: Maybe<Array<ProductVariantOption>>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnit?: Maybe<WeightUnit>;
};

export type ProductVariantInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Compare-at price in INTEGER CENTS, as `price` above. */
  compareAtPrice?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  initialQuantity?: InputMaybe<Scalars['Int']['input']>;
  isNew: Scalars['Boolean']['input'];
  /**
   * Selling price in INTEGER CENTS: 1999 is $19.99.
   *
   * Every money field this API carries is integer cents, which is also how it is
   * stored (MPPRO-45). Clients convert for display and for the figure a person
   * types, and nothing in between divides by 100.
   */
  price: Scalars['Float']['input'];
  quantityAdjustment?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  trackQuantity: Scalars['Boolean']['input'];
  variantOptions?: InputMaybe<Array<ProductVariantOptionInput>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type ProductVariantOption = {
  __typename?: 'ProductVariantOption';
  optionId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductVariantOptionInput = {
  optionId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  analytics?: Maybe<Analytics>;
  currentTermsVersion: Scalars['String']['output'];
  dashboardActions?: Maybe<DashboardActions>;
  deliveryProfile: DeliveryProfile;
  deliveryProfiles?: Maybe<Array<DeliveryProfile>>;
  displayNameExists?: Maybe<Scalars['Boolean']['output']>;
  handleExists?: Maybe<Scalars['Boolean']['output']>;
  me: User;
  payout?: Maybe<Payout>;
  payoutConnection?: Maybe<PayoutConnection>;
  payoutOptions?: Maybe<PayoutOptions>;
  paypalAccountLink?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productConnection?: Maybe<ProductConnection>;
  productImageConnection?: Maybe<ProductImageConnection>;
  /**
   * How many products the seller holds in each status.
   *
   * The products screen shows these counts beside its heading. Deriving them
   * client-side would mean either paging the whole catalogue or firing one
   * filtered query per status, so they are aggregated in a single search.
   */
  productStatusCounts: ProductStatusCounts;
  seller?: Maybe<Seller>;
  sellerOrder?: Maybe<SellerOrder>;
  sellerOrderConnection?: Maybe<SellerOrderConnection>;
  settings?: Maybe<SellerSettings>;
  statistics?: Maybe<Statistics>;
  stripeAccountLink?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  validateInvitation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Why an invitation link cannot be used, rather than only whether it can.
   * Kept alongside the Boolean above so existing callers are unaffected.
   */
  validateInvitationStatus: InvitationValidation;
};


export type QueryAnalyticsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  period?: InputMaybe<PeriodType>;
};


export type QueryDeliveryProfileArgs = {
  deliveryProfileId: Scalars['ID']['input'];
};


export type QueryDisplayNameExistsArgs = {
  displayName: Scalars['String']['input'];
};


export type QueryHandleExistsArgs = {
  handle: Scalars['String']['input'];
};


export type QueryPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<InputMaybe<TransactionType>>>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['Date']['input']>;
  createdBefore?: InputMaybe<Scalars['Date']['input']>;
  deliveryProfileId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  priceMax?: InputMaybe<Scalars['Float']['input']>;
  priceMin?: InputMaybe<Scalars['Float']['input']>;
  productStatus?: InputMaybe<Array<ProductStatus>>;
  productType?: InputMaybe<ProductType>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus?: InputMaybe<Array<ProductReviewStatus>>;
};


export type QueryProductImageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  selectedImageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySellerOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySellerOrderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderedAfter?: InputMaybe<Scalars['Date']['input']>;
  orderedBefore?: InputMaybe<Scalars['Date']['input']>;
  payoutPaid?: InputMaybe<Scalars['Boolean']['input']>;
  sellerOrderStatus?: InputMaybe<Array<SellerOrderStatus>>;
  totalMax?: InputMaybe<Scalars['Float']['input']>;
  totalMin?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  period?: InputMaybe<PeriodType>;
};


export type QueryStripeAccountLinkArgs = {
  type: StripeAccountLinkType;
};


export type QueryValidateInvitationArgs = {
  invitationCode: Scalars['String']['input'];
};


export type QueryValidateInvitationStatusArgs = {
  invitationCode: Scalars['String']['input'];
};

export type RegisterUserInput = {
  email: Scalars['String']['input'];
  family_name: Scalars['String']['input'];
  given_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ReturnsSetting = {
  __typename?: 'ReturnsSetting';
  noReturns: Scalars['Boolean']['output'];
  returnsTimeout: Scalars['Int']['output'];
};

export type Seller = {
  __typename?: 'Seller';
  about?: Maybe<Scalars['String']['output']>;
  address?: Maybe<SellerAddress>;
  bio?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Image>;
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idAlias: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  logo?: Maybe<Image>;
  notification?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  payoutAccount?: Maybe<PayoutAccount>;
  phone: Scalars['String']['output'];
  profileImage?: Maybe<Image>;
  settings: SellerSettings;
  status: SellerStatus;
  storeTitle?: Maybe<Scalars['String']['output']>;
  /**
   * The seller's public page on the shop's storefront, or null while there isn't
   * one to link to.
   *
   * Every seller is a Shopify metaobject whose definition this app creates with
   * the online-store capability and `urlHandle: 'seller'`, and the metaobject
   * handle is the seller's own `handle` — so the address is
   * `https://<shop>/seller/<handle>` and needs no Shopify call to derive. Null
   * until the seller is Active, because that is when the metaobject is published;
   * before then the page is a draft and the link would 404.
   */
  storefrontUrl?: Maybe<Scalars['String']['output']>;
  story?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<SellerTerms>;
  updatedAt: Scalars['Date']['output'];
};

export type SellerAddress = {
  __typename?: 'SellerAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  postCode?: Maybe<Scalars['String']['output']>;
  provinceCode?: Maybe<Scalars['String']['output']>;
};

export type SellerAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  postCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
};

export type SellerInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address: SellerAddressInput;
  bio?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['Upload']['input']>;
  displayName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  handle: Scalars['String']['input'];
  headline?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['Upload']['input']>;
  notification?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  storeTitle?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type SellerLocationSetting = {
  __typename?: 'SellerLocationSetting';
  allowedCountries: Array<Scalars['String']['output']>;
  hideSelectCountryIfSingleCountry: Scalars['Boolean']['output'];
  sellerLocationOption: SellerLocationSettingOption;
};

export enum SellerLocationSettingOption {
  AllCountries = 'ALL_COUNTRIES',
  CustomList = 'CUSTOM_LIST',
  ShopCountryOnly = 'SHOP_COUNTRY_ONLY'
}

export type SellerOrder = Node & {
  __typename?: 'SellerOrder';
  /**
   * When the seller accepted the order. Null for orders that were never accepted,
   * and for orders placed before this was recorded.
   */
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  appliedDeductions?: Maybe<Array<AppliedDeduction>>;
  createdAt: Scalars['Date']['output'];
  customer?: Maybe<Customer>;
  /** When the order was fulfilled. Null until fulfilment completes. */
  fulfilledAt?: Maybe<Scalars['Date']['output']>;
  fulfillment?: Maybe<Fulfillment>;
  id: Scalars['ID']['output'];
  idAlias: Scalars['String']['output'];
  items: Array<SellerOrderItem>;
  orderDate: Scalars['Date']['output'];
  orderFee: Scalars['Float']['output'];
  payout?: Maybe<Payout>;
  payoutId?: Maybe<Scalars['String']['output']>;
  /**
   * The part of `refundedPayoutTotal` applied after this order had already been paid
   * out. That money was not withheld from a payout and is not recovered automatically.
   */
  refundedAfterPayout?: Maybe<Scalars['Float']['output']>;
  /**
   * How much `totalPayout` has been reduced by refunds, in cents. `totalPayout` is
   * already net of this; the field explains the reduction rather than repeating it.
   */
  refundedPayoutTotal?: Maybe<Scalars['Float']['output']>;
  /**
   * Merchandise value refunded on this seller order, in cents. Null on orders that
   * have never been refunded.
   */
  refundedTotal?: Maybe<Scalars['Float']['output']>;
  shippingCommission?: Maybe<CalculatedShippingCommission>;
  shopifyOrderId: Scalars['String']['output'];
  status: SellerOrderStatus;
  total: Scalars['Float']['output'];
  totalFees: Scalars['Float']['output'];
  totalPayout: Scalars['Float']['output'];
  totalProductFees: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SellerOrderAcceptSetting = {
  __typename?: 'SellerOrderAcceptSetting';
  autoAccept: Scalars['Boolean']['output'];
  orderAcceptTimeout: Scalars['Int']['output'];
};

export type SellerOrderConnection = Connection & {
  __typename?: 'SellerOrderConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<Maybe<SellerOrderEdge>>>;
  pageInfo: PageInfo;
};

export type SellerOrderEdge = Edge & {
  __typename?: 'SellerOrderEdge';
  cursor: Scalars['String']['output'];
  node: SellerOrder;
};

export type SellerOrderFeeSetting = {
  __typename?: 'SellerOrderFeeSetting';
  orderFee: Scalars['Int']['output'];
};

export type SellerOrderFulfilledSetting = {
  __typename?: 'SellerOrderFulfilledSetting';
  autoFulfilled: Scalars['Boolean']['output'];
  orderFulfilledTimeout: Scalars['Int']['output'];
};

export type SellerOrderItem = {
  __typename?: 'SellerOrderItem';
  description: Scalars['String']['output'];
  featuredImage?: Maybe<ProductImageFile>;
  productCommission?: Maybe<CalculatedProductCommission>;
  productFee: Scalars['Float']['output'];
  productId: Scalars['ID']['output'];
  productIdAlias: Scalars['String']['output'];
  productThumbnail?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  productVariantId: Scalars['ID']['output'];
  productVariantOptions?: Maybe<Array<SellerOrderProductVariantOption>>;
  quantity: Scalars['Int']['output'];
  /** Units of this line refunded in Shopify so far. Null means none. */
  refundedQuantity?: Maybe<Scalars['Int']['output']>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  totalFees: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnit?: Maybe<WeightUnit>;
};

export type SellerOrderProductVariantOption = {
  __typename?: 'SellerOrderProductVariantOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SellerOrderStats = {
  __typename?: 'SellerOrderStats';
  accepted: Scalars['Int']['output'];
  fulfilled: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export enum SellerOrderStatus {
  AcceptTimeout = 'ACCEPT_TIMEOUT',
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  FulfillmentTimeout = 'FULFILLMENT_TIMEOUT',
  Pending = 'PENDING',
  PendingFulfillment = 'PENDING_FULFILLMENT',
  Rejected = 'REJECTED',
  RejectedThirdParty = 'REJECTED_THIRD_PARTY',
  WaitingThirdParty = 'WAITING_THIRD_PARTY'
}

export type SellerSettings = {
  __typename?: 'SellerSettings';
  commissionBasis: CommissionBasisSetting;
  deductions: DeductionsSetting;
  orderFee: SellerOrderFeeSetting;
  payoutPeriod: PayoutPeriodSetting;
  productFee: ProductFeeSetting;
  productPercentage: ProductPercentageSetting;
  productPublish: ProductPublishSetting;
  productReview: ProductReviewSetting;
  productShipping: ProductShippingSetting;
  productType: ProductTypeSetting;
  returns: ReturnsSetting;
  sellerLocation: SellerLocationSetting;
  sellerOrderAccept: SellerOrderAcceptSetting;
  sellerOrderFulfilled: SellerOrderFulfilledSetting;
  shippingPercentage: ShippingPercentageSetting;
  storefront: StorefrontSetting;
};

export enum SellerStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  DisableFailed = 'DISABLE_FAILED',
  Disabling = 'DISABLING',
  PendingApproval = 'PENDING_APPROVAL',
  PendingInvitation = 'PENDING_INVITATION',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  Suspending = 'SUSPENDING',
  SuspensionFailed = 'SUSPENSION_FAILED'
}

export type SellerTerms = {
  __typename?: 'SellerTerms';
  /** When the seller last accepted. Null if they never have. */
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  status: TermsStatus;
  termsAndConditions?: Maybe<TermsAndConditions>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SetDeliveryProfileInput = {
  default: DeliveryRateInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originCountryCode: Scalars['String']['input'];
  originPostalCode?: InputMaybe<Scalars['String']['input']>;
  originRegionCode?: InputMaybe<Scalars['String']['input']>;
  otherInternational?: InputMaybe<DeliveryRateInput>;
  processingTime: DeliveryProcessingTimeInput;
  productId?: InputMaybe<Scalars['ID']['input']>;
  zones?: InputMaybe<Array<DeliveryZoneInput>>;
};

export type SetSellerInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<SellerAddressInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['Upload']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  notification?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  storeTitle?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export enum ShippingCountryOfOriginOption {
  AllCountries = 'ALL_COUNTRIES',
  CustomList = 'CUSTOM_LIST',
  SellerCountryOnly = 'SELLER_COUNTRY_ONLY',
  ShopCountryOnly = 'SHOP_COUNTRY_ONLY'
}

export type ShippingPercentageSetting = {
  __typename?: 'ShippingPercentageSetting';
  shippingPercentage: Scalars['Int']['output'];
};

export type ShopSettings = {
  __typename?: 'ShopSettings';
  commissionBasis: CommissionBasisSetting;
  deductions: DeductionsSetting;
  orderFee: SellerOrderFeeSetting;
  payoutPeriod: PayoutPeriodSetting;
  productFee: ProductFeeSetting;
  productPercentage: ProductPercentageSetting;
  productPublish: ProductPublishSetting;
  productReview: ProductReviewSetting;
  productShipping: ProductShippingSetting;
  productType: ProductTypeSetting;
  returns: ReturnsSetting;
  sellerLocation: SellerLocationSetting;
  sellerOrderAccept: SellerOrderAcceptSetting;
  sellerOrderFulfilled: SellerOrderFulfilledSetting;
  shippingPercentage: ShippingPercentageSetting;
  storefront: StorefrontSetting;
};

export type StandardShipping = {
  __typename?: 'StandardShipping';
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  domesticRate: Scalars['Float']['output'];
  internationalRate?: Maybe<Scalars['Float']['output']>;
  processingTime?: Maybe<DeliveryProcessingTime>;
};

export type StandardShippingInput = {
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  domesticRate: Scalars['Float']['input'];
  internationalRate?: InputMaybe<Scalars['Float']['input']>;
  processingTime?: InputMaybe<DeliveryProcessingTimeInput>;
};

export type Statistics = {
  __typename?: 'Statistics';
  earnings: DashboardMetric;
  orders: DashboardMetric;
  products: Scalars['Int']['output'];
};

export type StorefrontSetting = {
  __typename?: 'StorefrontSetting';
  enabled: Scalars['Boolean']['output'];
  storefrontOptions: StorefrontSettingStorefrontOptions;
};

export type StorefrontSettingStorefrontOptions = {
  __typename?: 'StorefrontSettingStorefrontOptions';
  allowBanner: Scalars['Boolean']['output'];
  allowMessaging: Scalars['Boolean']['output'];
  allowNotification: Scalars['Boolean']['output'];
  allowOwnerBio: Scalars['Boolean']['output'];
  allowReviews: Scalars['Boolean']['output'];
  allowStory: Scalars['Boolean']['output'];
};

export enum StripeAccountLinkType {
  AccountOnboarding = 'ACCOUNT_ONBOARDING',
  AccountUpdate = 'ACCOUNT_UPDATE'
}

export type StripePayoutAccount = {
  __typename?: 'StripePayoutAccount';
  accountId: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  bankAccount?: Maybe<BankAccountDetails>;
  /**
   * What Stripe is waiting for, in Stripe's own field names
   * (`individual.verification.document`, `external_account`, `individual.id_number`).
   * Empty when nothing is outstanding, so `requirementsDue` is this list being
   * non-empty.
   *
   * The flag alone says only that something is wrong, which leaves the seller to
   * open Stripe to find out what — and the one screen that could have told them
   * is the one they were already looking at. Read from the connected account,
   * which is already fetched to compute `active`, so this costs no extra call.
   */
  outstandingRequirements: Array<Scalars['String']['output']>;
  /**
   * True when Stripe still wants something before it will pay out — identity
   * documents, a bank account, business details. Payouts are held meanwhile, so
   * the seller has to be told.
   */
  requirementsDue: Scalars['Boolean']['output'];
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export enum TermsStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Updated = 'UPDATED'
}

export type TrackingDetailsInput = {
  shippingCompany?: InputMaybe<Scalars['String']['input']>;
  trackingNumber: Scalars['String']['input'];
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum TransactionType {
  Bank = 'BANK',
  BankManual = 'BANK_MANUAL',
  Cash = 'CASH',
  Other = 'OTHER',
  Paypal = 'PAYPAL'
}

export type User = {
  __typename?: 'User';
  companyName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isRegistered: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  seller?: Maybe<Seller>;
  settings?: Maybe<ShopSettings>;
  shopManaged: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type UserLoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UserLoginTokensInput = {
  accessToken: Scalars['JWT']['input'];
  idToken: Scalars['JWT']['input'];
  refreshToken: Scalars['JWT']['input'];
  username: Scalars['String']['input'];
};

export type VerifyCodeInput = {
  code: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export enum WeightUnit {
  Grams = 'GRAMS',
  Kilograms = 'KILOGRAMS',
  Ounces = 'OUNCES',
  Pounds = 'POUNDS'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  PayoutAccount: ( PaypalPayoutAccount ) | ( StripePayoutAccount );
  PayoutTransaction: ( PayoutTransactionManual ) | ( PayoutTransactionPaypal ) | ( PayoutTransactionStripe );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  BaseImage: ( Image ) | ( ProductImageFile );
  Connection: ( Omit<PayoutConnection, 'edges'> & { edges?: Maybe<Array<Maybe<_RefType['PayoutEdge']>>> } ) | ( ProductConnection ) | ( ProductImageConnection ) | ( Omit<SellerOrderConnection, 'edges'> & { edges?: Maybe<Array<Maybe<_RefType['SellerOrderEdge']>>> } );
  Edge: ( Omit<PayoutEdge, 'node'> & { node: _RefType['Payout'] } ) | ( ProductEdge ) | ( ProductImageEdge ) | ( Omit<SellerOrderEdge, 'node'> & { node: _RefType['SellerOrder'] } );
  Node: ( Omit<Payout, 'orders' | 'transaction'> & { orders?: Maybe<_RefType['SellerOrderConnection']>, transaction: _RefType['PayoutTransaction'] } ) | ( Product ) | ( ProductImage ) | ( Omit<SellerOrder, 'appliedDeductions' | 'payout'> & { appliedDeductions?: Maybe<Array<_RefType['AppliedDeduction']>>, payout?: Maybe<_RefType['Payout']> } );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Analytics: ResolverTypeWrapper<Analytics>;
  AppliedDeduction: ResolverTypeWrapper<AppliedDeduction>;
  AuthTokens: ResolverTypeWrapper<AuthTokens>;
  AuthenticatedUser: ResolverTypeWrapper<Omit<AuthenticatedUser, 'user'> & { user: ResolversTypes['User'] }>;
  BankAccountDetails: ResolverTypeWrapper<BankAccountDetails>;
  BaseImage: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['BaseImage']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CalculatedProductCommission: ResolverTypeWrapper<CalculatedProductCommission>;
  CalculatedSellerOrderCommission: ResolverTypeWrapper<CalculatedSellerOrderCommission>;
  CalculatedShippingCommission: ResolverTypeWrapper<CalculatedShippingCommission>;
  CancelSellerOrderDetailsInput: CancelSellerOrderDetailsInput;
  CommissionBasis: CommissionBasis;
  CommissionBasisSetting: ResolverTypeWrapper<CommissionBasisSetting>;
  CompleteRegistrationInput: CompleteRegistrationInput;
  Connection: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Connection']>;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerAddress: ResolverTypeWrapper<CustomerAddress>;
  DashboardActions: ResolverTypeWrapper<DashboardActions>;
  DashboardMetric: ResolverTypeWrapper<DashboardMetric>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateRangeInput: DateRangeInput;
  Deduction: ResolverTypeWrapper<Deduction>;
  DeductionType: DeductionType;
  DeductionsSetting: ResolverTypeWrapper<DeductionsSetting>;
  DeliveryProcessingTime: ResolverTypeWrapper<DeliveryProcessingTime>;
  DeliveryProcessingTimeInput: DeliveryProcessingTimeInput;
  DeliveryProcessingTimeUnit: DeliveryProcessingTimeUnit;
  DeliveryProfile: ResolverTypeWrapper<DeliveryProfile>;
  DeliveryRate: ResolverTypeWrapper<DeliveryRate>;
  DeliveryRateInput: DeliveryRateInput;
  DeliveryRateType: DeliveryRateType;
  DeliveryZone: ResolverTypeWrapper<DeliveryZone>;
  DeliveryZoneCountry: ResolverTypeWrapper<DeliveryZoneCountry>;
  DeliveryZoneCountryInput: DeliveryZoneCountryInput;
  DeliveryZoneInput: DeliveryZoneInput;
  DeliveryZoneRegionInput: DeliveryZoneRegionInput;
  Edge: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Edge']>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  Fulfillment: ResolverTypeWrapper<Fulfillment>;
  FulfillmentDetailsInput: FulfillmentDetailsInput;
  FulfillmentStatus: FulfillmentStatus;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Image: ResolverTypeWrapper<Image>;
  InlineShippingOptions: InlineShippingOptions;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvitationStatus: InvitationStatus;
  InvitationValidation: ResolverTypeWrapper<InvitationValidation>;
  JWT: ResolverTypeWrapper<Scalars['JWT']['output']>;
  ManualPayoutTransactionType: ManualPayoutTransactionType;
  Mutation: ResolverTypeWrapper<{}>;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  OrdersData: ResolverTypeWrapper<OrdersData>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PasswordResetInput: PasswordResetInput;
  Payout: ResolverTypeWrapper<Omit<Payout, 'orders' | 'transaction'> & { orders?: Maybe<ResolversTypes['SellerOrderConnection']>, transaction: ResolversTypes['PayoutTransaction'] }>;
  PayoutAccount: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PayoutAccount']>;
  PayoutAdjustment: ResolverTypeWrapper<PayoutAdjustment>;
  PayoutAdjustmentInput: PayoutAdjustmentInput;
  PayoutCalculation: ResolverTypeWrapper<PayoutCalculation>;
  PayoutConnection: ResolverTypeWrapper<Omit<PayoutConnection, 'edges'> & { edges?: Maybe<Array<Maybe<ResolversTypes['PayoutEdge']>>> }>;
  PayoutEdge: ResolverTypeWrapper<Omit<PayoutEdge, 'node'> & { node: ResolversTypes['Payout'] }>;
  PayoutManualTo: ResolverTypeWrapper<PayoutManualTo>;
  PayoutOptions: ResolverTypeWrapper<PayoutOptions>;
  PayoutPaypalFrom: ResolverTypeWrapper<PayoutPaypalFrom>;
  PayoutPaypalTo: ResolverTypeWrapper<PayoutPaypalTo>;
  PayoutPeriodChoice: PayoutPeriodChoice;
  PayoutPeriodSetting: ResolverTypeWrapper<PayoutPeriodSetting>;
  PayoutStatus: PayoutStatus;
  PayoutStripeTo: ResolverTypeWrapper<PayoutStripeTo>;
  PayoutTransaction: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PayoutTransaction']>;
  PayoutTransactionManual: ResolverTypeWrapper<PayoutTransactionManual>;
  PayoutTransactionPaypal: ResolverTypeWrapper<PayoutTransactionPaypal>;
  PayoutTransactionStripe: ResolverTypeWrapper<PayoutTransactionStripe>;
  PaypalPayoutAccount: ResolverTypeWrapper<PaypalPayoutAccount>;
  PeriodRangeInput: PeriodRangeInput;
  PeriodType: PeriodType;
  Product: ResolverTypeWrapper<Product>;
  ProductConnection: ResolverTypeWrapper<ProductConnection>;
  ProductEdge: ResolverTypeWrapper<ProductEdge>;
  ProductFeeSetting: ResolverTypeWrapper<ProductFeeSetting>;
  ProductImage: ResolverTypeWrapper<ProductImage>;
  ProductImageConnection: ResolverTypeWrapper<ProductImageConnection>;
  ProductImageEdge: ResolverTypeWrapper<ProductImageEdge>;
  ProductImageFile: ResolverTypeWrapper<ProductImageFile>;
  ProductImageItemInput: ProductImageItemInput;
  ProductInfo: ResolverTypeWrapper<ProductInfo>;
  ProductInput: ProductInput;
  ProductOption: ResolverTypeWrapper<ProductOption>;
  ProductOptionInput: ProductOptionInput;
  ProductPercentageSetting: ResolverTypeWrapper<ProductPercentageSetting>;
  ProductPublishSetting: ResolverTypeWrapper<ProductPublishSetting>;
  ProductReviewAction: ProductReviewAction;
  ProductReviewSetting: ResolverTypeWrapper<ProductReviewSetting>;
  ProductReviewStatus: ProductReviewStatus;
  ProductSettings: ResolverTypeWrapper<ProductSettings>;
  ProductShippingSetting: ResolverTypeWrapper<ProductShippingSetting>;
  ProductStatus: ProductStatus;
  ProductStatusCounts: ResolverTypeWrapper<ProductStatusCounts>;
  ProductType: ProductType;
  ProductTypeOptions: ProductTypeOptions;
  ProductTypeSetting: ResolverTypeWrapper<ProductTypeSetting>;
  ProductUserContext: ProductUserContext;
  ProductVariant: ResolverTypeWrapper<ProductVariant>;
  ProductVariantInput: ProductVariantInput;
  ProductVariantOption: ResolverTypeWrapper<ProductVariantOption>;
  ProductVariantOptionInput: ProductVariantOptionInput;
  Query: ResolverTypeWrapper<{}>;
  RegisterUserInput: RegisterUserInput;
  ReturnsSetting: ResolverTypeWrapper<ReturnsSetting>;
  Seller: ResolverTypeWrapper<Omit<Seller, 'address' | 'payoutAccount'> & { address?: Maybe<ResolversTypes['SellerAddress']>, payoutAccount?: Maybe<ResolversTypes['PayoutAccount']> }>;
  SellerAddress: ResolverTypeWrapper<SellerAddress>;
  SellerAddressInput: SellerAddressInput;
  SellerInput: SellerInput;
  SellerLocationSetting: ResolverTypeWrapper<SellerLocationSetting>;
  SellerLocationSettingOption: SellerLocationSettingOption;
  SellerOrder: ResolverTypeWrapper<Omit<SellerOrder, 'appliedDeductions' | 'payout'> & { appliedDeductions?: Maybe<Array<ResolversTypes['AppliedDeduction']>>, payout?: Maybe<ResolversTypes['Payout']> }>;
  SellerOrderAcceptSetting: ResolverTypeWrapper<SellerOrderAcceptSetting>;
  SellerOrderConnection: ResolverTypeWrapper<Omit<SellerOrderConnection, 'edges'> & { edges?: Maybe<Array<Maybe<ResolversTypes['SellerOrderEdge']>>> }>;
  SellerOrderEdge: ResolverTypeWrapper<Omit<SellerOrderEdge, 'node'> & { node: ResolversTypes['SellerOrder'] }>;
  SellerOrderFeeSetting: ResolverTypeWrapper<SellerOrderFeeSetting>;
  SellerOrderFulfilledSetting: ResolverTypeWrapper<SellerOrderFulfilledSetting>;
  SellerOrderItem: ResolverTypeWrapper<SellerOrderItem>;
  SellerOrderProductVariantOption: ResolverTypeWrapper<SellerOrderProductVariantOption>;
  SellerOrderStats: ResolverTypeWrapper<SellerOrderStats>;
  SellerOrderStatus: SellerOrderStatus;
  SellerSettings: ResolverTypeWrapper<SellerSettings>;
  SellerStatus: SellerStatus;
  SellerTerms: ResolverTypeWrapper<SellerTerms>;
  SetDeliveryProfileInput: SetDeliveryProfileInput;
  SetSellerInput: SetSellerInput;
  ShippingCountryOfOriginOption: ShippingCountryOfOriginOption;
  ShippingPercentageSetting: ResolverTypeWrapper<ShippingPercentageSetting>;
  ShopSettings: ResolverTypeWrapper<ShopSettings>;
  StandardShipping: ResolverTypeWrapper<StandardShipping>;
  StandardShippingInput: StandardShippingInput;
  Statistics: ResolverTypeWrapper<Statistics>;
  StorefrontSetting: ResolverTypeWrapper<StorefrontSetting>;
  StorefrontSettingStorefrontOptions: ResolverTypeWrapper<StorefrontSettingStorefrontOptions>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StripeAccountLinkType: StripeAccountLinkType;
  StripePayoutAccount: ResolverTypeWrapper<StripePayoutAccount>;
  TermsAndConditions: ResolverTypeWrapper<TermsAndConditions>;
  TermsStatus: TermsStatus;
  TrackingDetailsInput: TrackingDetailsInput;
  TransactionType: TransactionType;
  URL: ResolverTypeWrapper<Scalars['URL']['output']>;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  User: ResolverTypeWrapper<Omit<User, 'seller'> & { seller?: Maybe<ResolversTypes['Seller']> }>;
  UserLoginInput: UserLoginInput;
  UserLoginTokensInput: UserLoginTokensInput;
  VerifyCodeInput: VerifyCodeInput;
  WeightUnit: WeightUnit;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Analytics: Analytics;
  AppliedDeduction: AppliedDeduction;
  AuthTokens: AuthTokens;
  AuthenticatedUser: Omit<AuthenticatedUser, 'user'> & { user: ResolversParentTypes['User'] };
  BankAccountDetails: BankAccountDetails;
  BaseImage: ResolversInterfaceTypes<ResolversParentTypes>['BaseImage'];
  Boolean: Scalars['Boolean']['output'];
  CalculatedProductCommission: CalculatedProductCommission;
  CalculatedSellerOrderCommission: CalculatedSellerOrderCommission;
  CalculatedShippingCommission: CalculatedShippingCommission;
  CancelSellerOrderDetailsInput: CancelSellerOrderDetailsInput;
  CommissionBasisSetting: CommissionBasisSetting;
  CompleteRegistrationInput: CompleteRegistrationInput;
  Connection: ResolversInterfaceTypes<ResolversParentTypes>['Connection'];
  Customer: Customer;
  CustomerAddress: CustomerAddress;
  DashboardActions: DashboardActions;
  DashboardMetric: DashboardMetric;
  Date: Scalars['Date']['output'];
  DateRangeInput: DateRangeInput;
  Deduction: Deduction;
  DeductionsSetting: DeductionsSetting;
  DeliveryProcessingTime: DeliveryProcessingTime;
  DeliveryProcessingTimeInput: DeliveryProcessingTimeInput;
  DeliveryProfile: DeliveryProfile;
  DeliveryRate: DeliveryRate;
  DeliveryRateInput: DeliveryRateInput;
  DeliveryZone: DeliveryZone;
  DeliveryZoneCountry: DeliveryZoneCountry;
  DeliveryZoneCountryInput: DeliveryZoneCountryInput;
  DeliveryZoneInput: DeliveryZoneInput;
  DeliveryZoneRegionInput: DeliveryZoneRegionInput;
  Edge: ResolversInterfaceTypes<ResolversParentTypes>['Edge'];
  Float: Scalars['Float']['output'];
  Fulfillment: Fulfillment;
  FulfillmentDetailsInput: FulfillmentDetailsInput;
  ID: Scalars['ID']['output'];
  Image: Image;
  Int: Scalars['Int']['output'];
  InvitationValidation: InvitationValidation;
  JWT: Scalars['JWT']['output'];
  Mutation: {};
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  OrdersData: OrdersData;
  PageInfo: PageInfo;
  PasswordResetInput: PasswordResetInput;
  Payout: Omit<Payout, 'orders' | 'transaction'> & { orders?: Maybe<ResolversParentTypes['SellerOrderConnection']>, transaction: ResolversParentTypes['PayoutTransaction'] };
  PayoutAccount: ResolversUnionTypes<ResolversParentTypes>['PayoutAccount'];
  PayoutAdjustment: PayoutAdjustment;
  PayoutAdjustmentInput: PayoutAdjustmentInput;
  PayoutCalculation: PayoutCalculation;
  PayoutConnection: Omit<PayoutConnection, 'edges'> & { edges?: Maybe<Array<Maybe<ResolversParentTypes['PayoutEdge']>>> };
  PayoutEdge: Omit<PayoutEdge, 'node'> & { node: ResolversParentTypes['Payout'] };
  PayoutManualTo: PayoutManualTo;
  PayoutOptions: PayoutOptions;
  PayoutPaypalFrom: PayoutPaypalFrom;
  PayoutPaypalTo: PayoutPaypalTo;
  PayoutPeriodSetting: PayoutPeriodSetting;
  PayoutStripeTo: PayoutStripeTo;
  PayoutTransaction: ResolversUnionTypes<ResolversParentTypes>['PayoutTransaction'];
  PayoutTransactionManual: PayoutTransactionManual;
  PayoutTransactionPaypal: PayoutTransactionPaypal;
  PayoutTransactionStripe: PayoutTransactionStripe;
  PaypalPayoutAccount: PaypalPayoutAccount;
  PeriodRangeInput: PeriodRangeInput;
  Product: Product;
  ProductConnection: ProductConnection;
  ProductEdge: ProductEdge;
  ProductFeeSetting: ProductFeeSetting;
  ProductImage: ProductImage;
  ProductImageConnection: ProductImageConnection;
  ProductImageEdge: ProductImageEdge;
  ProductImageFile: ProductImageFile;
  ProductImageItemInput: ProductImageItemInput;
  ProductInfo: ProductInfo;
  ProductInput: ProductInput;
  ProductOption: ProductOption;
  ProductOptionInput: ProductOptionInput;
  ProductPercentageSetting: ProductPercentageSetting;
  ProductPublishSetting: ProductPublishSetting;
  ProductReviewSetting: ProductReviewSetting;
  ProductSettings: ProductSettings;
  ProductShippingSetting: ProductShippingSetting;
  ProductStatusCounts: ProductStatusCounts;
  ProductTypeSetting: ProductTypeSetting;
  ProductVariant: ProductVariant;
  ProductVariantInput: ProductVariantInput;
  ProductVariantOption: ProductVariantOption;
  ProductVariantOptionInput: ProductVariantOptionInput;
  Query: {};
  RegisterUserInput: RegisterUserInput;
  ReturnsSetting: ReturnsSetting;
  Seller: Omit<Seller, 'address' | 'payoutAccount'> & { address?: Maybe<ResolversParentTypes['SellerAddress']>, payoutAccount?: Maybe<ResolversParentTypes['PayoutAccount']> };
  SellerAddress: SellerAddress;
  SellerAddressInput: SellerAddressInput;
  SellerInput: SellerInput;
  SellerLocationSetting: SellerLocationSetting;
  SellerOrder: Omit<SellerOrder, 'appliedDeductions' | 'payout'> & { appliedDeductions?: Maybe<Array<ResolversParentTypes['AppliedDeduction']>>, payout?: Maybe<ResolversParentTypes['Payout']> };
  SellerOrderAcceptSetting: SellerOrderAcceptSetting;
  SellerOrderConnection: Omit<SellerOrderConnection, 'edges'> & { edges?: Maybe<Array<Maybe<ResolversParentTypes['SellerOrderEdge']>>> };
  SellerOrderEdge: Omit<SellerOrderEdge, 'node'> & { node: ResolversParentTypes['SellerOrder'] };
  SellerOrderFeeSetting: SellerOrderFeeSetting;
  SellerOrderFulfilledSetting: SellerOrderFulfilledSetting;
  SellerOrderItem: SellerOrderItem;
  SellerOrderProductVariantOption: SellerOrderProductVariantOption;
  SellerOrderStats: SellerOrderStats;
  SellerSettings: SellerSettings;
  SellerTerms: SellerTerms;
  SetDeliveryProfileInput: SetDeliveryProfileInput;
  SetSellerInput: SetSellerInput;
  ShippingPercentageSetting: ShippingPercentageSetting;
  ShopSettings: ShopSettings;
  StandardShipping: StandardShipping;
  StandardShippingInput: StandardShippingInput;
  Statistics: Statistics;
  StorefrontSetting: StorefrontSetting;
  StorefrontSettingStorefrontOptions: StorefrontSettingStorefrontOptions;
  String: Scalars['String']['output'];
  StripePayoutAccount: StripePayoutAccount;
  TermsAndConditions: TermsAndConditions;
  TrackingDetailsInput: TrackingDetailsInput;
  URL: Scalars['URL']['output'];
  Upload: Scalars['Upload']['output'];
  User: Omit<User, 'seller'> & { seller?: Maybe<ResolversParentTypes['Seller']> };
  UserLoginInput: UserLoginInput;
  UserLoginTokensInput: UserLoginTokensInput;
  VerifyCodeInput: VerifyCodeInput;
};

export type AnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Analytics'] = ResolversParentTypes['Analytics']> = {
  currentPeriodOrders?: Resolver<Array<ResolversTypes['OrdersData']>, ParentType, ContextType>;
  currentPeriodOrdersQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currentPeriodOrdersValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  previousPeriodOrders?: Resolver<Array<ResolversTypes['OrdersData']>, ParentType, ContextType>;
  previousPeriodOrdersQuantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previousPeriodOrdersValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedDeductionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedDeduction'] = ResolversParentTypes['AppliedDeduction']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeductionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthTokensResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthTokens'] = ResolversParentTypes['AuthTokens']> = {
  accessToken?: Resolver<ResolversTypes['JWT'], ParentType, ContextType>;
  idToken?: Resolver<ResolversTypes['JWT'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['JWT'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthenticatedUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticatedUser'] = ResolversParentTypes['AuthenticatedUser']> = {
  tokens?: Resolver<ResolversTypes['AuthTokens'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountDetails'] = ResolversParentTypes['BankAccountDetails']> = {
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  last4Digits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseImage'] = ResolversParentTypes['BaseImage']> = {
  __resolveType: TypeResolveFn<'Image' | 'ProductImageFile', ParentType, ContextType>;
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CalculatedProductCommissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalculatedProductCommission'] = ResolversParentTypes['CalculatedProductCommission']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  base?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  basis?: Resolver<Maybe<ResolversTypes['CommissionBasis']>, ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unitCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalculatedSellerOrderCommissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalculatedSellerOrderCommission'] = ResolversParentTypes['CalculatedSellerOrderCommission']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalculatedShippingCommissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalculatedShippingCommission'] = ResolversParentTypes['CalculatedShippingCommission']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommissionBasisSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommissionBasisSetting'] = ResolversParentTypes['CommissionBasisSetting']> = {
  basis?: Resolver<ResolversTypes['CommissionBasis'], ParentType, ContextType>;
  showSellerCost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Connection'] = ResolversParentTypes['Connection']> = {
  __resolveType: TypeResolveFn<'PayoutConnection' | 'ProductConnection' | 'ProductImageConnection' | 'SellerOrderConnection', ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['Edge']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['CustomerAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAddress'] = ResolversParentTypes['CustomerAddress']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provinceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardActionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DashboardActions'] = ResolversParentTypes['DashboardActions']> = {
  ordersPendingApproval?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ordersPendingFulfillment?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['DashboardMetric'] = ResolversParentTypes['DashboardMetric']> = {
  changePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DeductionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Deduction'] = ResolversParentTypes['Deduction']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeductionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeductionsSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeductionsSetting'] = ResolversParentTypes['DeductionsSetting']> = {
  deductions?: Resolver<Array<ResolversTypes['Deduction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryProcessingTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryProcessingTime'] = ResolversParentTypes['DeliveryProcessingTime']> = {
  max?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['DeliveryProcessingTimeUnit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryProfile'] = ResolversParentTypes['DeliveryProfile']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  default?: Resolver<ResolversTypes['DeliveryRate'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originCountryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originPostalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originRegionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  otherInternational?: Resolver<Maybe<ResolversTypes['DeliveryRate']>, ParentType, ContextType>;
  processingTime?: Resolver<ResolversTypes['DeliveryProcessingTime'], ParentType, ContextType>;
  productCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  zones?: Resolver<Array<ResolversTypes['DeliveryZone']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryRate'] = ResolversParentTypes['DeliveryRate']> = {
  additionalItemRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeliveryRateType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryZone'] = ResolversParentTypes['DeliveryZone']> = {
  countries?: Resolver<Array<ResolversTypes['DeliveryZoneCountry']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['DeliveryRate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryZoneCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryZoneCountry'] = ResolversParentTypes['DeliveryZoneCountry']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Edge'] = ResolversParentTypes['Edge']> = {
  __resolveType: TypeResolveFn<'PayoutEdge' | 'ProductEdge' | 'ProductImageEdge' | 'SellerOrderEdge', ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Node']>, ParentType, ContextType>;
};

export type FulfillmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Fulfillment'] = ResolversParentTypes['Fulfillment']> = {
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  shippingCarrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shippingCarrierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FulfillmentStatus'], ParentType, ContextType>;
  trackingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = {
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitationValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvitationValidation'] = ResolversParentTypes['InvitationValidation']> = {
  status?: Resolver<ResolversTypes['InvitationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JwtScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JWT'], any> {
  name: 'JWT';
}

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptInvitation?: Resolver<ResolversTypes['AuthenticatedUser'], ParentType, ContextType, RequireFields<MutationAcceptInvitationArgs, 'invitationCode' | 'password'>>;
  acceptSellerOrder?: Resolver<Maybe<ResolversTypes['SellerOrder']>, ParentType, ContextType, RequireFields<MutationAcceptSellerOrderArgs, 'accepted' | 'id'>>;
  acceptTerms?: Resolver<ResolversTypes['Seller'], ParentType, ContextType, RequireFields<MutationAcceptTermsArgs, 'version'>>;
  addProductImage?: Resolver<ResolversTypes['ProductImageFile'], ParentType, ContextType, RequireFields<MutationAddProductImageArgs, 'image'>>;
  cancelSellerOrder?: Resolver<Maybe<ResolversTypes['SellerOrder']>, ParentType, ContextType, RequireFields<MutationCancelSellerOrderArgs, 'details' | 'id'>>;
  completeRegistration?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationCompleteRegistrationArgs, 'completeRegistration'>>;
  createProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<MutationCreateProductArgs, 'product'>>;
  deletePayoutAccount?: Resolver<ResolversTypes['Seller'], ParentType, ContextType>;
  deleteProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteProductArgs, 'id'>>;
  forgotPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationForgotPasswordArgs, 'username'>>;
  forgotPasswordReset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationForgotPasswordResetArgs, 'value'>>;
  fulfillSellerOrder?: Resolver<Maybe<ResolversTypes['SellerOrder']>, ParentType, ContextType, RequireFields<MutationFulfillSellerOrderArgs, 'id'>>;
  login?: Resolver<ResolversTypes['AuthenticatedUser'], ParentType, ContextType, RequireFields<MutationLoginArgs, 'value'>>;
  loginSession?: Resolver<ResolversTypes['AuthenticatedUser'], ParentType, ContextType, RequireFields<MutationLoginSessionArgs, 'value'>>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  refreshAccessToken?: Resolver<ResolversTypes['AuthenticatedUser'], ParentType, ContextType, RequireFields<MutationRefreshAccessTokenArgs, 'refreshToken' | 'username'>>;
  register?: Resolver<ResolversTypes['AuthenticatedUser'], ParentType, ContextType, RequireFields<MutationRegisterArgs, 'value'>>;
  resendCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResendCodeArgs, 'username'>>;
  setDeliveryProfile?: Resolver<ResolversTypes['DeliveryProfile'], ParentType, ContextType, RequireFields<MutationSetDeliveryProfileArgs, 'deliveryProfile'>>;
  setSeller?: Resolver<Maybe<ResolversTypes['Seller']>, ParentType, ContextType, RequireFields<MutationSetSellerArgs, 'input'>>;
  updateFulfillment?: Resolver<Maybe<ResolversTypes['SellerOrder']>, ParentType, ContextType, RequireFields<MutationUpdateFulfillmentArgs, 'id' | 'trackingInfo'>>;
  updateProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<MutationUpdateProductArgs, 'product'>>;
  updateSeller?: Resolver<Maybe<ResolversTypes['Seller']>, ParentType, ContextType, RequireFields<MutationUpdateSellerArgs, 'seller'>>;
  verifyCode?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationVerifyCodeArgs, 'value'>>;
};

export type NodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = {
  __resolveType: TypeResolveFn<'Payout' | 'Product' | 'ProductImage' | 'SellerOrder', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type OrdersDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersData'] = ResolversParentTypes['OrdersData']> = {
  key?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payout'] = ResolversParentTypes['Payout']> = {
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orders?: Resolver<Maybe<ResolversTypes['SellerOrderConnection']>, ParentType, ContextType, Partial<PayoutOrdersArgs>>;
  payout?: Resolver<Maybe<ResolversTypes['PayoutCalculation']>, ParentType, ContextType>;
  payoutDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  payoutDueDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  transaction?: Resolver<ResolversTypes['PayoutTransaction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutAccount'] = ResolversParentTypes['PayoutAccount']> = {
  __resolveType: TypeResolveFn<'PaypalPayoutAccount' | 'StripePayoutAccount', ParentType, ContextType>;
};

export type PayoutAdjustmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutAdjustment'] = ResolversParentTypes['PayoutAdjustment']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutCalculationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutCalculation'] = ResolversParentTypes['PayoutCalculation']> = {
  adjustment?: Resolver<Maybe<ResolversTypes['PayoutAdjustment']>, ParentType, ContextType>;
  calculatedPayoutAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  payoutAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutConnection'] = ResolversParentTypes['PayoutConnection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['PayoutEdge']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutEdge'] = ResolversParentTypes['PayoutEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Payout'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutManualToResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutManualTo'] = ResolversParentTypes['PayoutManualTo']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ManualPayoutTransactionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutOptions'] = ResolversParentTypes['PayoutOptions']> = {
  paypal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  stripe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutPaypalFromResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutPaypalFrom'] = ResolversParentTypes['PayoutPaypalFrom']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutPaypalToResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutPaypalTo'] = ResolversParentTypes['PayoutPaypalTo']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutPeriodSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutPeriodSetting'] = ResolversParentTypes['PayoutPeriodSetting']> = {
  payoutPeriod?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payoutPeriodChoice?: Resolver<ResolversTypes['PayoutPeriodChoice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutStripeToResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutStripeTo'] = ResolversParentTypes['PayoutStripeTo']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  last4Digits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutTransaction'] = ResolversParentTypes['PayoutTransaction']> = {
  __resolveType: TypeResolveFn<'PayoutTransactionManual' | 'PayoutTransactionPaypal' | 'PayoutTransactionStripe', ParentType, ContextType>;
};

export type PayoutTransactionManualResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutTransactionManual'] = ResolversParentTypes['PayoutTransactionManual']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['PayoutManualTo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutTransactionPaypalResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutTransactionPaypal'] = ResolversParentTypes['PayoutTransactionPaypal']> = {
  from?: Resolver<ResolversTypes['PayoutPaypalFrom'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['PayoutPaypalTo'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutTransactionStripeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutTransactionStripe'] = ResolversParentTypes['PayoutTransactionStripe']> = {
  to?: Resolver<ResolversTypes['PayoutStripeTo'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaypalPayoutAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaypalPayoutAccount'] = ResolversParentTypes['PaypalPayoutAccount']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = {
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['ProductUserContext'], ParentType, ContextType>;
  current?: Resolver<Maybe<ResolversTypes['ProductInfo']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDetatched?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['ProductInfo']>, ParentType, ContextType>;
  rejectedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewStatus?: Resolver<ResolversTypes['ProductReviewStatus'], ParentType, ContextType>;
  settings?: Resolver<Maybe<ResolversTypes['ProductSettings']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProductStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['ProductUserContext']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConnection'] = ResolversParentTypes['ProductConnection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductEdge']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductEdge'] = ResolversParentTypes['ProductEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductFeeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductFeeSetting'] = ResolversParentTypes['ProductFeeSetting']> = {
  productFee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductImage'] = ResolversParentTypes['ProductImage']> = {
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ProductImageFile'], ParentType, ContextType>;
  isConnected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFeatured?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductImageConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductImageConnection'] = ResolversParentTypes['ProductImageConnection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductImageEdge']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductImageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductImageEdge'] = ResolversParentTypes['ProductImageEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProductImage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductImageFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductImageFile'] = ResolversParentTypes['ProductImageFile']> = {
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductInfo'] = ResolversParentTypes['ProductInfo']> = {
  deliveryProfile?: Resolver<Maybe<ResolversTypes['DeliveryProfile']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  images?: Resolver<Maybe<Array<ResolversTypes['ProductImage']>>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<ResolversTypes['ProductOption']>>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  standardShipping?: Resolver<Maybe<ResolversTypes['StandardShipping']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variants?: Resolver<Array<ResolversTypes['ProductVariant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductOption'] = ResolversParentTypes['ProductOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPercentageSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPercentageSetting'] = ResolversParentTypes['ProductPercentageSetting']> = {
  productPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPublishSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPublishSetting'] = ResolversParentTypes['ProductPublishSetting']> = {
  activateOnAccept?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publishOnlineOnAccept?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductReviewSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductReviewSetting'] = ResolversParentTypes['ProductReviewSetting']> = {
  reviewAction?: Resolver<ResolversTypes['ProductReviewAction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSettings'] = ResolversParentTypes['ProductSettings']> = {
  commissionBasis?: Resolver<ResolversTypes['CommissionBasisSetting'], ParentType, ContextType>;
  productFee?: Resolver<ResolversTypes['ProductFeeSetting'], ParentType, ContextType>;
  productPercentage?: Resolver<ResolversTypes['ProductPercentageSetting'], ParentType, ContextType>;
  productReview?: Resolver<ResolversTypes['ProductReviewSetting'], ParentType, ContextType>;
  returns?: Resolver<ResolversTypes['ReturnsSetting'], ParentType, ContextType>;
  shippingPercentage?: Resolver<ResolversTypes['ShippingPercentageSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductShippingSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductShippingSetting'] = ResolversParentTypes['ProductShippingSetting']> = {
  allowAllInternationalShippingCountries?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowProfiles?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowedInternationalShippingCountries?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  customShippingCountryOfOriginList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  hideSelectCountryIfSingleCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inlineShippingOptions?: Resolver<ResolversTypes['InlineShippingOptions'], ParentType, ContextType>;
  shippingCountryOfOriginOption?: Resolver<ResolversTypes['ShippingCountryOfOriginOption'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductStatusCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductStatusCounts'] = ResolversParentTypes['ProductStatusCounts']> = {
  active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  archived?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  awaitingReview?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  changesRequested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  draft?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  new?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductTypeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductTypeSetting'] = ResolversParentTypes['ProductTypeSetting']> = {
  productType?: Resolver<ResolversTypes['ProductTypeOptions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariant'] = ResolversParentTypes['ProductVariant']> = {
  barcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compareAtPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImageFile']>, ParentType, ContextType>;
  initialQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isNew?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantityAdjustment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trackQuantity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  variantOptions?: Resolver<Maybe<Array<ResolversTypes['ProductVariantOption']>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weightUnit?: Resolver<Maybe<ResolversTypes['WeightUnit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductVariantOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductVariantOption'] = ResolversParentTypes['ProductVariantOption']> = {
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType, Partial<QueryAnalyticsArgs>>;
  currentTermsVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dashboardActions?: Resolver<Maybe<ResolversTypes['DashboardActions']>, ParentType, ContextType>;
  deliveryProfile?: Resolver<ResolversTypes['DeliveryProfile'], ParentType, ContextType, RequireFields<QueryDeliveryProfileArgs, 'deliveryProfileId'>>;
  deliveryProfiles?: Resolver<Maybe<Array<ResolversTypes['DeliveryProfile']>>, ParentType, ContextType>;
  displayNameExists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryDisplayNameExistsArgs, 'displayName'>>;
  handleExists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryHandleExistsArgs, 'handle'>>;
  me?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['Payout']>, ParentType, ContextType, RequireFields<QueryPayoutArgs, 'id'>>;
  payoutConnection?: Resolver<Maybe<ResolversTypes['PayoutConnection']>, ParentType, ContextType, Partial<QueryPayoutConnectionArgs>>;
  payoutOptions?: Resolver<Maybe<ResolversTypes['PayoutOptions']>, ParentType, ContextType>;
  paypalAccountLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<QueryProductArgs, 'id'>>;
  productConnection?: Resolver<Maybe<ResolversTypes['ProductConnection']>, ParentType, ContextType, Partial<QueryProductConnectionArgs>>;
  productImageConnection?: Resolver<Maybe<ResolversTypes['ProductImageConnection']>, ParentType, ContextType, Partial<QueryProductImageConnectionArgs>>;
  productStatusCounts?: Resolver<ResolversTypes['ProductStatusCounts'], ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['Seller']>, ParentType, ContextType>;
  sellerOrder?: Resolver<Maybe<ResolversTypes['SellerOrder']>, ParentType, ContextType, RequireFields<QuerySellerOrderArgs, 'id'>>;
  sellerOrderConnection?: Resolver<Maybe<ResolversTypes['SellerOrderConnection']>, ParentType, ContextType, Partial<QuerySellerOrderConnectionArgs>>;
  settings?: Resolver<Maybe<ResolversTypes['SellerSettings']>, ParentType, ContextType>;
  statistics?: Resolver<Maybe<ResolversTypes['Statistics']>, ParentType, ContextType, Partial<QueryStatisticsArgs>>;
  stripeAccountLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryStripeAccountLinkArgs, 'type'>>;
  termsAndConditions?: Resolver<Maybe<ResolversTypes['TermsAndConditions']>, ParentType, ContextType>;
  validateInvitation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryValidateInvitationArgs, 'invitationCode'>>;
  validateInvitationStatus?: Resolver<ResolversTypes['InvitationValidation'], ParentType, ContextType, RequireFields<QueryValidateInvitationStatusArgs, 'invitationCode'>>;
};

export type ReturnsSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReturnsSetting'] = ResolversParentTypes['ReturnsSetting']> = {
  noReturns?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  returnsTimeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Seller'] = ResolversParentTypes['Seller']> = {
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['SellerAddress']>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  handle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  notification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payoutAccount?: Resolver<Maybe<ResolversTypes['PayoutAccount']>, ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['SellerSettings'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SellerStatus'], ParentType, ContextType>;
  storeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storefrontUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  story?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tagline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['SellerTerms']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerAddress'] = ResolversParentTypes['SellerAddress']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provinceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerLocationSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerLocationSetting'] = ResolversParentTypes['SellerLocationSetting']> = {
  allowedCountries?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  hideSelectCountryIfSingleCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sellerLocationOption?: Resolver<ResolversTypes['SellerLocationSettingOption'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrder'] = ResolversParentTypes['SellerOrder']> = {
  acceptedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  appliedDeductions?: Resolver<Maybe<Array<ResolversTypes['AppliedDeduction']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  customer?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  fulfilledAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fulfillment?: Resolver<Maybe<ResolversTypes['Fulfillment']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SellerOrderItem']>, ParentType, ContextType>;
  orderDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  orderFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['Payout']>, ParentType, ContextType>;
  payoutId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundedAfterPayout?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  refundedPayoutTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  refundedTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shippingCommission?: Resolver<Maybe<ResolversTypes['CalculatedShippingCommission']>, ParentType, ContextType>;
  shopifyOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SellerOrderStatus'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPayout?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalProductFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderAcceptSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderAcceptSetting'] = ResolversParentTypes['SellerOrderAcceptSetting']> = {
  autoAccept?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orderAcceptTimeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderConnection'] = ResolversParentTypes['SellerOrderConnection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['SellerOrderEdge']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderEdge'] = ResolversParentTypes['SellerOrderEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SellerOrder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderFeeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderFeeSetting'] = ResolversParentTypes['SellerOrderFeeSetting']> = {
  orderFee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderFulfilledSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderFulfilledSetting'] = ResolversParentTypes['SellerOrderFulfilledSetting']> = {
  autoFulfilled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orderFulfilledTimeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderItem'] = ResolversParentTypes['SellerOrderItem']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  featuredImage?: Resolver<Maybe<ResolversTypes['ProductImageFile']>, ParentType, ContextType>;
  productCommission?: Resolver<Maybe<ResolversTypes['CalculatedProductCommission']>, ParentType, ContextType>;
  productFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productIdAlias?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  productVariantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productVariantOptions?: Resolver<Maybe<Array<ResolversTypes['SellerOrderProductVariantOption']>>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refundedQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shippingPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unitPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weightUnit?: Resolver<Maybe<ResolversTypes['WeightUnit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderProductVariantOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderProductVariantOption'] = ResolversParentTypes['SellerOrderProductVariantOption']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerOrderStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerOrderStats'] = ResolversParentTypes['SellerOrderStats']> = {
  accepted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fulfilled?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rejected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerSettings'] = ResolversParentTypes['SellerSettings']> = {
  commissionBasis?: Resolver<ResolversTypes['CommissionBasisSetting'], ParentType, ContextType>;
  deductions?: Resolver<ResolversTypes['DeductionsSetting'], ParentType, ContextType>;
  orderFee?: Resolver<ResolversTypes['SellerOrderFeeSetting'], ParentType, ContextType>;
  payoutPeriod?: Resolver<ResolversTypes['PayoutPeriodSetting'], ParentType, ContextType>;
  productFee?: Resolver<ResolversTypes['ProductFeeSetting'], ParentType, ContextType>;
  productPercentage?: Resolver<ResolversTypes['ProductPercentageSetting'], ParentType, ContextType>;
  productPublish?: Resolver<ResolversTypes['ProductPublishSetting'], ParentType, ContextType>;
  productReview?: Resolver<ResolversTypes['ProductReviewSetting'], ParentType, ContextType>;
  productShipping?: Resolver<ResolversTypes['ProductShippingSetting'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductTypeSetting'], ParentType, ContextType>;
  returns?: Resolver<ResolversTypes['ReturnsSetting'], ParentType, ContextType>;
  sellerLocation?: Resolver<ResolversTypes['SellerLocationSetting'], ParentType, ContextType>;
  sellerOrderAccept?: Resolver<ResolversTypes['SellerOrderAcceptSetting'], ParentType, ContextType>;
  sellerOrderFulfilled?: Resolver<ResolversTypes['SellerOrderFulfilledSetting'], ParentType, ContextType>;
  shippingPercentage?: Resolver<ResolversTypes['ShippingPercentageSetting'], ParentType, ContextType>;
  storefront?: Resolver<ResolversTypes['StorefrontSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerTermsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerTerms'] = ResolversParentTypes['SellerTerms']> = {
  acceptedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TermsStatus'], ParentType, ContextType>;
  termsAndConditions?: Resolver<Maybe<ResolversTypes['TermsAndConditions']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShippingPercentageSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShippingPercentageSetting'] = ResolversParentTypes['ShippingPercentageSetting']> = {
  shippingPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShopSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopSettings'] = ResolversParentTypes['ShopSettings']> = {
  commissionBasis?: Resolver<ResolversTypes['CommissionBasisSetting'], ParentType, ContextType>;
  deductions?: Resolver<ResolversTypes['DeductionsSetting'], ParentType, ContextType>;
  orderFee?: Resolver<ResolversTypes['SellerOrderFeeSetting'], ParentType, ContextType>;
  payoutPeriod?: Resolver<ResolversTypes['PayoutPeriodSetting'], ParentType, ContextType>;
  productFee?: Resolver<ResolversTypes['ProductFeeSetting'], ParentType, ContextType>;
  productPercentage?: Resolver<ResolversTypes['ProductPercentageSetting'], ParentType, ContextType>;
  productPublish?: Resolver<ResolversTypes['ProductPublishSetting'], ParentType, ContextType>;
  productReview?: Resolver<ResolversTypes['ProductReviewSetting'], ParentType, ContextType>;
  productShipping?: Resolver<ResolversTypes['ProductShippingSetting'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductTypeSetting'], ParentType, ContextType>;
  returns?: Resolver<ResolversTypes['ReturnsSetting'], ParentType, ContextType>;
  sellerLocation?: Resolver<ResolversTypes['SellerLocationSetting'], ParentType, ContextType>;
  sellerOrderAccept?: Resolver<ResolversTypes['SellerOrderAcceptSetting'], ParentType, ContextType>;
  sellerOrderFulfilled?: Resolver<ResolversTypes['SellerOrderFulfilledSetting'], ParentType, ContextType>;
  shippingPercentage?: Resolver<ResolversTypes['ShippingPercentageSetting'], ParentType, ContextType>;
  storefront?: Resolver<ResolversTypes['StorefrontSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandardShippingResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandardShipping'] = ResolversParentTypes['StandardShipping']> = {
  countryOfOrigin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domesticRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  internationalRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingTime?: Resolver<Maybe<ResolversTypes['DeliveryProcessingTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Statistics'] = ResolversParentTypes['Statistics']> = {
  earnings?: Resolver<ResolversTypes['DashboardMetric'], ParentType, ContextType>;
  orders?: Resolver<ResolversTypes['DashboardMetric'], ParentType, ContextType>;
  products?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorefrontSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorefrontSetting'] = ResolversParentTypes['StorefrontSetting']> = {
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  storefrontOptions?: Resolver<ResolversTypes['StorefrontSettingStorefrontOptions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorefrontSettingStorefrontOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorefrontSettingStorefrontOptions'] = ResolversParentTypes['StorefrontSettingStorefrontOptions']> = {
  allowBanner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowMessaging?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowOwnerBio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowReviews?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowStory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StripePayoutAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripePayoutAccount'] = ResolversParentTypes['StripePayoutAccount']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccountDetails']>, ParentType, ContextType>;
  outstandingRequirements?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  requirementsDue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TermsAndConditionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TermsAndConditions'] = ResolversParentTypes['TermsAndConditions']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['Seller']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<ResolversTypes['ShopSettings']>, ParentType, ContextType>;
  shopManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Analytics?: AnalyticsResolvers<ContextType>;
  AppliedDeduction?: AppliedDeductionResolvers<ContextType>;
  AuthTokens?: AuthTokensResolvers<ContextType>;
  AuthenticatedUser?: AuthenticatedUserResolvers<ContextType>;
  BankAccountDetails?: BankAccountDetailsResolvers<ContextType>;
  BaseImage?: BaseImageResolvers<ContextType>;
  CalculatedProductCommission?: CalculatedProductCommissionResolvers<ContextType>;
  CalculatedSellerOrderCommission?: CalculatedSellerOrderCommissionResolvers<ContextType>;
  CalculatedShippingCommission?: CalculatedShippingCommissionResolvers<ContextType>;
  CommissionBasisSetting?: CommissionBasisSettingResolvers<ContextType>;
  Connection?: ConnectionResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  CustomerAddress?: CustomerAddressResolvers<ContextType>;
  DashboardActions?: DashboardActionsResolvers<ContextType>;
  DashboardMetric?: DashboardMetricResolvers<ContextType>;
  Date?: GraphQLScalarType;
  Deduction?: DeductionResolvers<ContextType>;
  DeductionsSetting?: DeductionsSettingResolvers<ContextType>;
  DeliveryProcessingTime?: DeliveryProcessingTimeResolvers<ContextType>;
  DeliveryProfile?: DeliveryProfileResolvers<ContextType>;
  DeliveryRate?: DeliveryRateResolvers<ContextType>;
  DeliveryZone?: DeliveryZoneResolvers<ContextType>;
  DeliveryZoneCountry?: DeliveryZoneCountryResolvers<ContextType>;
  Edge?: EdgeResolvers<ContextType>;
  Fulfillment?: FulfillmentResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  InvitationValidation?: InvitationValidationResolvers<ContextType>;
  JWT?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  OrdersData?: OrdersDataResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Payout?: PayoutResolvers<ContextType>;
  PayoutAccount?: PayoutAccountResolvers<ContextType>;
  PayoutAdjustment?: PayoutAdjustmentResolvers<ContextType>;
  PayoutCalculation?: PayoutCalculationResolvers<ContextType>;
  PayoutConnection?: PayoutConnectionResolvers<ContextType>;
  PayoutEdge?: PayoutEdgeResolvers<ContextType>;
  PayoutManualTo?: PayoutManualToResolvers<ContextType>;
  PayoutOptions?: PayoutOptionsResolvers<ContextType>;
  PayoutPaypalFrom?: PayoutPaypalFromResolvers<ContextType>;
  PayoutPaypalTo?: PayoutPaypalToResolvers<ContextType>;
  PayoutPeriodSetting?: PayoutPeriodSettingResolvers<ContextType>;
  PayoutStripeTo?: PayoutStripeToResolvers<ContextType>;
  PayoutTransaction?: PayoutTransactionResolvers<ContextType>;
  PayoutTransactionManual?: PayoutTransactionManualResolvers<ContextType>;
  PayoutTransactionPaypal?: PayoutTransactionPaypalResolvers<ContextType>;
  PayoutTransactionStripe?: PayoutTransactionStripeResolvers<ContextType>;
  PaypalPayoutAccount?: PaypalPayoutAccountResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductConnection?: ProductConnectionResolvers<ContextType>;
  ProductEdge?: ProductEdgeResolvers<ContextType>;
  ProductFeeSetting?: ProductFeeSettingResolvers<ContextType>;
  ProductImage?: ProductImageResolvers<ContextType>;
  ProductImageConnection?: ProductImageConnectionResolvers<ContextType>;
  ProductImageEdge?: ProductImageEdgeResolvers<ContextType>;
  ProductImageFile?: ProductImageFileResolvers<ContextType>;
  ProductInfo?: ProductInfoResolvers<ContextType>;
  ProductOption?: ProductOptionResolvers<ContextType>;
  ProductPercentageSetting?: ProductPercentageSettingResolvers<ContextType>;
  ProductPublishSetting?: ProductPublishSettingResolvers<ContextType>;
  ProductReviewSetting?: ProductReviewSettingResolvers<ContextType>;
  ProductSettings?: ProductSettingsResolvers<ContextType>;
  ProductShippingSetting?: ProductShippingSettingResolvers<ContextType>;
  ProductStatusCounts?: ProductStatusCountsResolvers<ContextType>;
  ProductTypeSetting?: ProductTypeSettingResolvers<ContextType>;
  ProductVariant?: ProductVariantResolvers<ContextType>;
  ProductVariantOption?: ProductVariantOptionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReturnsSetting?: ReturnsSettingResolvers<ContextType>;
  Seller?: SellerResolvers<ContextType>;
  SellerAddress?: SellerAddressResolvers<ContextType>;
  SellerLocationSetting?: SellerLocationSettingResolvers<ContextType>;
  SellerOrder?: SellerOrderResolvers<ContextType>;
  SellerOrderAcceptSetting?: SellerOrderAcceptSettingResolvers<ContextType>;
  SellerOrderConnection?: SellerOrderConnectionResolvers<ContextType>;
  SellerOrderEdge?: SellerOrderEdgeResolvers<ContextType>;
  SellerOrderFeeSetting?: SellerOrderFeeSettingResolvers<ContextType>;
  SellerOrderFulfilledSetting?: SellerOrderFulfilledSettingResolvers<ContextType>;
  SellerOrderItem?: SellerOrderItemResolvers<ContextType>;
  SellerOrderProductVariantOption?: SellerOrderProductVariantOptionResolvers<ContextType>;
  SellerOrderStats?: SellerOrderStatsResolvers<ContextType>;
  SellerSettings?: SellerSettingsResolvers<ContextType>;
  SellerTerms?: SellerTermsResolvers<ContextType>;
  ShippingPercentageSetting?: ShippingPercentageSettingResolvers<ContextType>;
  ShopSettings?: ShopSettingsResolvers<ContextType>;
  StandardShipping?: StandardShippingResolvers<ContextType>;
  Statistics?: StatisticsResolvers<ContextType>;
  StorefrontSetting?: StorefrontSettingResolvers<ContextType>;
  StorefrontSettingStorefrontOptions?: StorefrontSettingStorefrontOptionsResolvers<ContextType>;
  StripePayoutAccount?: StripePayoutAccountResolvers<ContextType>;
  TermsAndConditions?: TermsAndConditionsResolvers<ContextType>;
  URL?: GraphQLScalarType;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
};

